export abstract class EnumObject<T = string> {
	protected constructor(public readonly code: T) {}

	public is(another: EnumObject<T> | T | null | undefined): boolean {
		if (another === undefined || another === null) {
			return false;
		}

		if (another instanceof EnumObject) {
			return this.code === another.code;
		}

		if (this.constructor.toString() === (another as any).constructor.toString()) {
			return this.code === (<any>another).code;
		}

		return this.code === another;
	}

	public isNot(another: EnumObject<T> | T | null | undefined): boolean {
		return !this.is(another);
	}

	public isIn(another: (EnumObject<T> | T)[] | null): boolean {
		if (another === undefined || another === null) {
			return false;
		}
		const isAny = another.find((a) => this.is(a));
		return !!isAny;
	}

	public isNotIn(another: (EnumObject<T> | T)[] | null): boolean {
		return !this.isIn(another);
	}
}
